import {z} from 'zod';

import {FinancialProductMoneySchema} from './FinancialProductMoneySchema';
import {FinancialProductSelectionSchema} from './FinancialProductSelectionSchema';
import {FinancialProductTypeSchema} from './FinancialProductTypeSchema';
import {FinancingCellSchema} from './FinancingCellSchema';
import {LeasingCellSchema} from './LeasingCellSchema';
import {LeasingTargetGroupSchema} from './LeasingTargetGroupSchema';

export const FinancialProductOfferDimensionsSchema = z.object({
  productType: FinancialProductTypeSchema,
  providerName: z.string().nullable(),
  validFrom: z.string().nullable(),
  validTo: z.string().nullable(),
  availableTerms: z.array(z.number()),
  /** Requests between brackets use the lower bracket's rates. */
  availableDownPaymentPercentages: z.array(z.number()),
  downPaymentStep: z.number(),
  availableBalloonPaymentPercentages: z.array(z.number()),
  availableTargetGroups: z.array(LeasingTargetGroupSchema),
  availableLeasingCells: z.array(LeasingCellSchema),
  /**
   * Empty on leasing and on a contract snapshot. Optional until every backend publishes it; when
   * absent, controls fall back to the union lists above.
   */
  availableFinancingCells: z.array(FinancingCellSchema).optional(),
  /**
   * Financing only: the fee added to the gross credit and the total payable (amount "0.00" when
   * none is configured). Published exactly when the financing cells carry rates; null on leasing
   * and whenever the rates are withheld. Optional until every backend publishes it.
   */
  processingFee: FinancialProductMoneySchema.nullable().optional(),
  /**
   * Leasing only: the display-only down payment of every leasing quote (amount "0.00" when none is
   * declared). Published exactly when the leasing cells carry rates; null on financing and
   * whenever the rates are withheld. Optional until every backend publishes it.
   */
  leasingDownPayment: FinancialProductMoneySchema.nullable().optional(),
  selection: FinancialProductSelectionSchema.nullable(),
  /** The vehicle's configured default; optional until every backend publishes it. */
  defaultSelection: FinancialProductSelectionSchema.nullable().optional(),
});
export type FinancialProductOfferDimensions = z.infer<typeof FinancialProductOfferDimensionsSchema>;
